var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-analyses-skeleton"},_vm._l((10),function(n){return _c('div',{key:n,staticClass:"product-analyses-skeleton__paragraph"},[_c('SkeletonLoader',{attrs:{"type":"paragraph"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }